<template>
  <div class="bg-base-100 rounded-lg p-6">
    <!-- Planners and Others Table -->
    <div class="mb-8">
      <div class="flex justify-between mb-6">
        <h2 class="text-xl font-semibold">Planuotojai ir administracija</h2>
      </div>

      <div class="overflow-x-auto">
        <table class="table w-full">
          <thead>
            <tr>
              <th>Vardas, Pavardė</th>
              <th>Pareigos</th>
              <th>Telefonas</th>
              <th>El. paštas</th>
              <th>Statusas</th>
              <th v-if="displayAction">Veiksmai</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in userStore.nonDrivers" :key="user.id">
              <td>{{ user.name }} {{ user.surname }}</td>
              <td>{{ roleConfig[user.role].text || user.role }}</td>
              <td>{{ user.phone }}</td>
              <td>{{ user.email }}</td>
              <td>
                <span
                  :class="[
                    'badge badge-sm badge-outline',
                    statusConfig[user.status].class,
                  ]"
                >
                  {{ statusConfig[user.status].text }}
                </span>
              </td>
              <td v-if="displayAction">
                <div class="flex gap-2">
                  <router-link
                    :to="'/users/' + user.id + '/edit'"
                    class="btn btn-sm btn-ghost btn-circle"
                    title="Redaguoti įrašą"
                  >
                    <DefaultIcon name="editPencil" size="w-4 h-4" />
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="mt-6 bg-base-100 rounded-lg p-6">
    <!-- Drivers Table -->
    <div>
      <div class="flex justify-between mb-6">
        <h2 class="text-xl font-semibold">Vairuotojai</h2>
      </div>

      <div class="overflow-x-auto">
        <table class="table w-full">
          <thead>
            <tr>
              <th>Vardas, Pavardė</th>
              <th>Pareigos</th>
              <th>Telefonas</th>
              <th>El. paštas</th>
              <th>Statusas</th>
              <th v-if="displayAction">Veiksmai</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in userStore.drivers" :key="user.id">
              <td>{{ user.name }} {{ user.surname }}</td>
              <td>{{ roleConfig[user.role].text || user.role }}</td>
              <td>{{ user.phone }}</td>
              <td>{{ user.email }}</td>
              <td>
                <span
                  :class="[
                    'badge badge-sm badge-outline',
                    statusConfig[user.status].class,
                  ]"
                >
                  {{ statusConfig[user.status].text }}
                </span>
              </td>
              <td v-if="displayAction">
                <div class="flex gap-2">
                  <router-link
                    :to="'/users/' + user.id + '/edit'"
                    class="btn btn-sm btn-ghost btn-circle"
                    title="Redaguoti įrašą"
                  >
                    <DefaultIcon name="editPencil" size="w-4 h-4" />
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores/auth";
import { onMounted, computed } from "vue";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const userStore = useAuthStore();

const roleConfig = {
  driver: {
    text: "Vairuotojas",
  },
  planner: {
    text: "Planuotojas",
  },
};

const statusConfig = {
  working: {
    text: "Dirba",
    class: "badge-success",
  },
  "on vacation": {
    text: "Atostogauja",
    class: "badge-warning",
  },
};

onMounted(async () => {
  try {
    await userStore.fetchUsers();
  } catch (error) {
    console.error("Failed to fetch users:", error);
  }
});

const displayAction = computed(() => {
  return userStore.user.role === "planner";
});
</script>
